module.exports = __webpack_public_path__ + "img/homeNoticeImg.22306b80.png";